import { FeedbackCategory } from '../components/InlineFeedbackDialog';
import { ObservableMap } from 'mobx';

/**
 * We should have up to 4 suggestions and up to 4 categories within each suggestion
 * The function will return true if at least one category is selected
 */
export default function anySubCategoriesSelected(
    subCategories: ObservableMap<string, FeedbackCategory[]>
) {
    let anySubCategoriesSelected: boolean = false;

    if (subCategories) {
        subCategories.forEach((value, key, map) => {
            anySubCategoriesSelected = (value.length > 0 && !!value[0]) || anySubCategoriesSelected;
        });
    }
    return anySubCategoriesSelected;
}
